// src/utils/avatarUtils.ts
// Initials avatar utilities - deterministic color and initials

/** Warm pastel palette aligned with app (terracotta, steel, cream, coffee) */
const AVATAR_PALETTE = [
  { bg: '#F5DFCE', text: '#594A42' }, // light terracotta
  { bg: '#D4E5ED', text: '#594A42' }, // light steel
  { bg: '#E8DED5', text: '#594A42' }, // light coffee/beige
  { bg: '#E2D5F1', text: '#594A42' }, // light lavender
  { bg: '#D4EDDA', text: '#594A42' }, // light sage
  { bg: '#FFF3CD', text: '#594A42' }, // light sand
] as const;

/**
 * Simple 32-bit string hash for deterministic color selection
 */
function hashString(str: string): number {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    const char = str.charCodeAt(i);
    hash = (hash << 5) - hash + char;
    hash = hash & hash;
  }
  return Math.abs(hash);
}

/**
 * Get uppercase initials from first and last name.
 * "Finley Jones" → "FJ", "Finley" → "F", "" → "?"
 */
export function getInitials(
  firstName?: string | null,
  lastName?: string | null
): string {
  const first = (firstName ?? '').trim().charAt(0)?.toUpperCase() || '';
  const last = (lastName ?? '').trim().charAt(0)?.toUpperCase() || '';
  return (first + last) || '?';
}

/**
 * Get deterministic background and text color for a user based on name or userId.
 * Same input always returns same color.
 */
export function getColorForName(
  firstName?: string | null,
  lastName?: string | null,
  userId?: string | null
): { bg: string; text: string } {
  const seed =
    (`${firstName ?? ''}${lastName ?? ''}`.trim() || userId) ?? '?';
  const hash = hashString(seed);
  const index = hash % AVATAR_PALETTE.length;
  return AVATAR_PALETTE[index];
}
